export default __webpack_public_path__ + "static/media/SphereCoreTelos.c094086d.webp";